import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { IAppConfig } from './modules/shared/models/app-config.model';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AppConfig {

  static settings: IAppConfig;
  private static readonly defaultFormioAppUrl = 'ujthdjjhctfrgsg.form.io';
  private static readonly defaultFormioApiUrl = 'https://api.form.io';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static FormioAppConfig: any;
  private httpClient: HttpClient;


    constructor(private handler: HttpBackend) {
      this.httpClient = new HttpClient(handler);
    }

    load() {
        const jsonFile = `assets/config/config.${environment.name}.json`;

        return new Promise<void>((resolve, reject) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          firstValueFrom(this.httpClient.get<any>(jsonFile))
          .then(response => {
               // Compat con configs desplegadas que aún usan el typo 'humanageOnbording'.
               if (response?.microfrontends && response.microfrontends.humanageOnboarding == null) {
                 response.microfrontends.humanageOnboarding = response.microfrontends.humanageOnbording;
               }
               AppConfig.settings = <IAppConfig>response;
               const configuredPdfInspectorFlag: unknown = AppConfig.settings.application.useFlagPdfInspector;
               AppConfig.settings.application.useFlagPdfInspector = configuredPdfInspectorFlag === true
                 || (typeof configuredPdfInspectorFlag === 'string'
                   && configuredPdfInspectorFlag.trim().toLowerCase() === 'true');
               AppConfig.FormioAppConfig = {
                 // Mantener el comportamiento legacy si el deploy no inyecta
                 // la sección formio en el archivo de configuración.
                 appUrl: typeof AppConfig.settings.formio?.appUrl === 'string'
                   ? AppConfig.settings.formio.appUrl.trim() || AppConfig.defaultFormioAppUrl
                   : AppConfig.defaultFormioAppUrl,
                 apiUrl: typeof AppConfig.settings.formio?.apiUrl === 'string'
                   ? AppConfig.settings.formio.apiUrl.trim() || AppConfig.defaultFormioApiUrl
                   : AppConfig.defaultFormioApiUrl
               };
               resolve();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }).catch((response: any) => {
               reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}
